/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.item-slider').lightSlider({
          item:4,
          loop:false,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:600,
          pause: 5000,
          auto: false,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          responsive : [
            {
              breakpoint:992,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]
        });

        $('#listNews').lightSlider({
          item:3,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:700,
          pause: 3000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          pager: false,
          responsive : [
            {
              breakpoint:992,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]

        });
        $('#listMayIn').lightSlider({
          item:3,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:700,
          pause: 3000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          pager: false,
          responsive : [
            {
              breakpoint:992,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]

        });
        $('#listDocThe').lightSlider({
          item:3,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:700,
          pause: 3000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          pager: false,
          responsive : [
            {
              breakpoint:992,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]

        });
        $('#listVatTu').lightSlider({
          item:3,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:700,
          pause: 4000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          pager: false,
          responsive : [
            {
              breakpoint:992,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]

        });
        $('#listChamcong').lightSlider({
          item:3,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:700,
          pause: 4000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          pager: false,
          responsive : [
            {
              breakpoint:992,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]

        });
        $('#listCamera').lightSlider({
          item:3,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:700,
          pause: 4000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          pager: false,
          responsive : [
            {
              breakpoint:992,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]

        });
        $('.category #gallery-1').lightSlider({
          item:3,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:700,
          pause: 4000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          pager: false,
          responsive : [
            {
              breakpoint:992,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]

        });
        $('.category #gallery-2').lightSlider({
          item:3,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:700,
          pause: 4000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          pager: false,
          responsive : [
            {
              breakpoint:992,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]

        });
        $('#listCustomers').lightSlider({
          item:6,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:600,
          pause: 5000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 5,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          pager: false,
          responsive : [
            {
              breakpoint:768,
              settings: {
                item:4
              }
            },
            {
              breakpoint:480,
              settings: {
                item:2
              }
            }
          ]
        });

        $('#imageGallery').lightSlider({
          item:3,
          loop:true,
          easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
          speed:600,
          pause: 5000,
          auto: true,
          pauseOnHover: true,
          slideMargin: 30,
          prevHtml: '<span class="glyphicon glyphicon-chevron-left"></span>',
          nextHtml: '<span class="glyphicon glyphicon-chevron-right"></span>',
          responsive : [
            {
              breakpoint:768,
              settings: {
                item:2
              }
            },
            {
              breakpoint:480,
              settings: {
                item:1
              }
            }
          ]
        });


        $('a[href="#btn-search"]').click(function(e){
          e.preventDefault();
          if ($(this).hasClass('clicked')){
            $(this).removeClass('clicked');
          }else{
            $(this).addClass('clicked');
          }

          if ($(this).hasClass('clicked')){
            $('#search-in-topmenu').fadeIn();
          }else{
            $('#search-in-topmenu').fadeOut();
          }

        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        //Window Scroll
        $(window).scroll(function(){

          if ($(this).scrollTop() > 150) {
            $('#scrollToTop').fadeIn();
          } else {
            $('#scrollToTop').fadeOut();
          }
        });

        //Scroll to top button clicked
        $('#scrollToTop').click(function(){
          $('html, body').animate({scrollTop : 0},800);
          return false;
        });

        $('#search-btn').click(function(event){
          event.preventDefault();
          if($(this).hasClass('active')){
            $(this).removeClass('active');
            $('.search-block .search-form').fadeOut();
          }else{
            $(this).addClass('active');
            $('.search-block .search-form').fadeIn();
          }
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
